export default __webpack_public_path__ + "static/media/bg.20672fc6.png";